import { Menu } from '@headlessui/react'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { socialLinks } from '../../../constants/links'
import { useDebounce } from '../../../hooks/utils'
import { AnimationTransition } from '../../Animation'
import { Close, Dots } from '../../Icons'

/**
 * @return {JSX.Element}
 */
export function Dropdown() {
  const [debouncedHover, setDebouncedHover] = useState(false)
  const [hover, setHover] = useState(false)
  const DebouncedHover = useDebounce([debouncedHover, hover], 200)

  useEffect(() => {
    const [debouncedHover] = DebouncedHover
    setHover(debouncedHover)
  }, [DebouncedHover])

  return (
    <Menu
      as="div"
      onMouseEnter={() => {
        setHover(true)
        setDebouncedHover(true)
      }}
      className="group"
      onMouseLeave={() => setDebouncedHover(false)}
    >
      <Menu.Button
        as="div"
        className="items-center justify-end table-cell pr-4 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-transparent focus-visible:ring-opacity-75"
      >
        <Dots
          height="35px"
          width="35px"
          className="transition-all duration-500 ease-in-out rounded-lg group-hover:bg-pollingactive bg-buttonbg fill-primarybg stroke-primarybg group-hover:opacity-50"
        />
      </Menu.Button>
      <AnimationTransition show={hover}>
        <Menu.Items
          as="div"
          className="absolute z-10 grid items-center px-2 py-2 mt-0 overflow-hidden origin-top-right border border-orange-500 rounded-lg shadow-lg cursor-pointer gap-x-4 w-fit group top-12 right-3 ring-1 ring-transparent ring-opacity-5 focus:outline-none"
        >
          <CloseButton setHover={setHover} setDebouncedHover={setDebouncedHover} />
          {socialLinks.map(({ title, href, icon }) => (
            <div
              key={'PopoverPanel<>' + title + href}
              className="hover:opacity-80 z-10 rounded-lg cursor-pointer transform-all h-[30px] text-sm hover:bg-gray-500 group flex items-center w-full gap-2 px-2"
              onClick={() => {
                setHover(false)
                setDebouncedHover(false)
                window.open(`${href}`, '_blank')
              }}
            >
              <Menu.Button as="button" className="-ml-[6px] w-auto rounded-full px-1 pl-2">
                {icon}
              </Menu.Button>
              <span className="justify-center pr-1 font-normal text-polling text-xxs tracking-default">
                {title}
              </span>
            </div>
          ))}
          <div className="top-0 left-0 custom-backdrop-blur z-1" />
        </Menu.Items>
      </AnimationTransition>
    </Menu>
  )
}
/**
 * @return {JSX.Element} Close Button
 */
function CloseButton({
  setHover,
  setDebouncedHover,
}: {
  setHover: Dispatch<SetStateAction<boolean>>
  setDebouncedHover: Dispatch<SetStateAction<boolean>>
}) {
  return (
    <Menu.Button
      as="button"
      onClick={() => {
        setHover(false)
        setDebouncedHover(false)
      }}
      className="z-[99] md:hidden flex place-content-end w-full min-w-max -m-0.5 "
    >
      <Close
        width="20px"
        height="20px"
        className="duration-500 ease-in-out delay-300 fill-primary hover:opacity-50"
      />
    </Menu.Button>
  )
}
